const ITEM_MULTIPLIER = 1; // This should always be 1 or it'll create multiples in the d3 chart

const getPathId = (links, nodeId) => {
  const prev = links.find(v => v.target === nodeId);

  if (prev) {
    return getPathId(links, prev.source);
  }

  return nodeId;
};

export const convertFromResourceToData = (resource) => {
  const amountItemResources = resource.attr('amountItems').resources().list();

  const amountItems = amountItemResources.reduce((acc, curr) => {
    for (let i = 0; i < ITEM_MULTIPLIER; i++) {
      acc.push(curr);
    }

    return acc;
  }, []);

  const isTwoColumnLayout = amountItems.length === 1;

  const getAccountNameId = (i) => `${i}`;
  const getAmountNodeId = (i) => `${i + amountItems.length}`;
  const getResultNodeId = () => `${2 * amountItems.length}`;

  const accountNameNodes = amountItems.map(((res, i) => ({
    nodeId: getAccountNameId(i),
    icon: res.attr('icon'),
    label: res.attr('label'),
    interval: res.attr('interval'),
    semantic: 'account-name',
    linksWith: isTwoColumnLayout ? getResultNodeId() : getAmountNodeId(i),
    value: 1,
  })));

  // In a 2 column layout we don't show the amount nodes
  const amountNodes = isTwoColumnLayout ? [] : amountItems.map(((res, i) => ({
    nodeId: getAmountNodeId(i),
    icon: res.attr('icon'),
    label: res.attr('amount'),
    semantic: 'amount',
    linksWith: getResultNodeId(),
    value: 1,
  })));

  const resultNode = {
    nodeId: getResultNodeId(),
    icon: 'fac',
    label: resource.attr('totalFundingAmount'),
    semantic: 'result',
    value: 0,
  };

  const nodes = [...accountNameNodes, ...amountNodes, resultNode];

  const links = nodes.filter(v => {
    return v.linksWith;
  }).map((node) => {
    return {
      source: node.nodeId,
      target: node.linksWith,
      value: node.value,
    };
  });

  return {
    nodes,
    links: links.map(v => ({
      ...v,
      pathId: getPathId(links, v.source),
    })),
  };
};
